// Token 管理工具类
export class TokenManager {
  // 获取 accessToken
  static getAccessToken(): string | null {
    return localStorage.getItem('accessToken');
  }

  // 设置 token
  static setToken(accessToken: string): void {
    localStorage.setItem('accessToken', accessToken);
    
    // 调试信息
    console.log('Token 已存储:', {
      accessToken: accessToken ? `${accessToken.substring(0, 20)}...` : 'null',
      userInfo: this.getUserFromToken(accessToken)
    });
  }

  // 清除 token
  static clearToken(): void {
    localStorage.removeItem('accessToken');
    
    // 调试信息
    console.log('Token 已清除');
  }

  // 检查是否有有效的 token
  static hasValidToken(): boolean {
    const accessToken = this.getAccessToken();
    if (!accessToken) {
      return false;
    }
    
    // 检查 token 是否过期
    const isExpired = this.isTokenExpired(accessToken);
    
    // 调试信息
    console.log('Token 检查:', {
      hasToken: !!accessToken,
      isExpired,
      isValid: !isExpired
    });
    
    return !isExpired;
  }

  // 解析 JWT token
  static parseToken(token: string): any {
    try {
      const payloadPart = token.split('.')[1];
      if (!payloadPart) return null;
      const normalized = payloadPart.replace(/-/g, '+').replace(/_/g, '/');
      const padded = normalized.padEnd(Math.ceil(normalized.length / 4) * 4, '=');
      // JWT 载荷是 UTF-8，直接 atob 会把中文用户名解成乱码
      const binary = atob(padded);
      const bytes = Uint8Array.from(binary, (char) => char.charCodeAt(0));
      const payload = JSON.parse(new TextDecoder().decode(bytes));
      return payload;
    } catch (error) {
      return null;
    }
  }

  // 检查 token 是否过期
  static isTokenExpired(token: string): boolean {
    const payload = this.parseToken(token);
    if (!payload) return true;
    
    const currentTime = Math.floor(Date.now() / 1000);
    return payload.exp < currentTime;
  }

  // 从 token 中获取用户信息
  static getUserFromToken(token: string): any {
    const payload = this.parseToken(token);
    return payload;
  }
}

// 导出默认实例
export default TokenManager;
